import styled from 'styled-components'
import { animation } from '@styles/vars/animation.style'
import { cubicBezier } from '@styles/vars/cubicBezier.style'

const getTransformDelay = props => {
  if (props.show) {
    const animationDelay =
      props.type.indexOf('chars') > -1
        ? animation.charDuration
        : props.type.indexOf('words') > -1
        ? animation.wordDuration
        : animation.lineDuration
    return `calc(${props.delay}s + ${animationDelay} * var(--splitTextDelay))`
  }
}

const getOpacityDelay = props => {
  if (props.show) {
    const animationDelay =
      props.type.indexOf('chars') > -1
        ? animation.charDuration
        : props.type.indexOf('words') > -1
        ? animation.wordDuration
        : animation.lineDuration
    return `calc(${props.delay}s + ${animationDelay} * var(--splitTextDelay))`
  } else {
    return `${props.duration}s`
  }
}

const getTranslate = props => {
  switch (props.enterFrom) {
    case 'top':
      return `translateY(-${props.offset})`
    case 'bottom':
      return `translateY(${props.offset})`
    case 'right':
      return `translateX(${props.offset})`
    case 'left':
      return `translateX(-${props.offset})`

    default:
      break
  }
}

export const SplitTextWrapper = styled.span`
  display: block;
  opacity: ${props => (props.isSplit ? 1 : 0)};

  .split__mask {
    padding-bottom: 0.06em;

    &:not(:first-child) {
      margin-top: -0.06em;
    }

    &:last-child {
      margin-bottom: -0.06em;
    }
  }

  .split__text {
    display: inline-block;
    will-change: transform;
    opacity: ${props =>
      props.enterTransparent ? (props.show ? 1 : 0) : undefined};
    transform: ${props =>
      props.show ? 'translate(0, 0)' : getTranslate(props)};
    transition: transform ${props => props.duration}s ${cubicBezier.inOut}
        ${props => getTransformDelay(props)},
      opacity 0s ${props => getOpacityDelay(props)};
  }
`
